import angular from 'angular'

import { WebRegisterStatusManager } from '../managers/web-register-status-manager'

/**
 * Resolves the webRegisterStatusManager that manages whether to trigger offline mode, any jobs or migrations
 * to run, etc.
 *
 * @module webregister.resolvers.webRegisterStatusManagerResolver
 */
angular
  .module('webregister.resolvers')
  .factory('webRegisterStatusManagerResolver', StatusManagerResolverFactory)

function StatusManagerResolverFactory(
  webRegisterStatusManager: WebRegisterStatusManager
) {
  return webRegisterStatusManager.init()
}
